import { useState } from "react"
import { arrayOf, func, number, shape, string } from "prop-types"
import axios from "axios"
import pcoURL from "@planningcenter/url"

import { Paginate, Table } from "components/ui"
import { Button, Tooltip } from "@planningcenter/tapestry-react"

const OrganizationsTable = ({
  organizations: organizationsFromProps,
  pagination: paginationFromProps,
  onChartOrganization
}) => {
  const [organizations, setOrganizations] = useState(organizationsFromProps)
  const [pagination, setPagination] = useState(paginationFromProps)

  const columns = [
    {
      cell: "organizationId",
      label: "ID",
      isSortable: false,
      render: (row, _col) => row.account_center_id
    },
    {
      cell: "organizationName",
      label: "Name",
      isSortable: false,
      render: (row, _col) => row.name
    },
    {
      cell: "organizationEventsCount",
      label: "Events",
      isSortable: false,
      render: (row, _col) => row.events_count
    },
    {
      cell: "organizationLostRevenue",
      label: "Lost Revenue",
      isSortable: false,
      render: (row, _col) =>
        "$" + (row.lost_revenue_cents / 100.0).toLocaleString("en-US", { minimumFractionDigits: 2 })
    },
    {
      cell: "organizationActions",
      label: "Actions",
      isSortable: false,
      render: (row, _col) => (
        <>
          <Tooltip placement="top" title="Show chart for organization">
            <Button
              theme="flat"
              icon={{ name: "general.funnel" }}
              title="Show Chart"
              aria-label="Show Chart"
              onClick={onChartOrganization(row.account_center_id)}
            />
          </Tooltip>
          <Tooltip placement="top" title="Impersonate organization">
            <Button
              as="a"
              href={`${pcoURL(window.railsEnv)("registrations")}/O${row.account_center_id}`}
              theme="flat"
              icon={{ name: "general.link" }}
              title="Impersonate Organization"
              aria-label="Impersonate Organization"
            />
          </Tooltip>
        </>
      )
    }
  ]

  const handleNavClick = page => {
    axios
      .get(`${pcoURL(window.railsEnv)("registrations")}/staff/overages`, {
        headers: {
          Accept: "application/json"
        },
        params: page
      })
      .then(response => {
        setOrganizations(response.data.organizations)
        setPagination(response.data.pagination)
      })
  }

  return (
    <div>
      <Table columns={columns} rows={organizations} className="table " />
      <div className="pagination-wrapper">
        <Paginate pagination={pagination} onNavClick={handleNavClick} />
      </div>
    </div>
  )
}

OrganizationsTable.propTypes = {
  organizations: arrayOf(
    shape({
      id: number,
      account_center_id: number,
      name: string,
      events_count: number,
      lost_revenue_cents: number
    })
  ),
  pagination: shape({
    nextPage: number,
    prevPage: number,
    totalPages: number,
    currentPage: number
  }),
  onChartOrganization: func
}

export default OrganizationsTable
